import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function getOrCreateSessionId() {
  let id = localStorage.getItem("chat_session_id");
  if (!id) {
    id = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    localStorage.setItem("chat_session_id", id);
  }
  return id;
}

export function getOrCreateVisitorId() {
  let id = localStorage.getItem("visitor_id");
  if (!id) {
    id = `v_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("visitor_id", id);
  }
  return id;
}

export async function trackVisit() {
  if (sessionStorage.getItem("visit_tracked")) return;
  sessionStorage.setItem("visit_tracked", "1");
  try {
    await api.post("/track-visit", { visitor_id: getOrCreateVisitorId() });
  } catch {
    sessionStorage.removeItem("visit_tracked");
  }
}
